import Heading from '../../components/atoms/Heading'
import Layout from '../../templates/Layout'
import InvoicesTable from '../../templates/InvoicesTable'

const PendingInvoicesPage = () => {
  return (
    <Layout>
      <Heading type="1" border margin>
        Facturas En Analisis
      </Heading>
      <InvoicesTable status="analysis"/>
      <Heading type="1" border margin>
        Facturas Listas Para Facturar
      </Heading>
      <InvoicesTable status="pending"/>
    </Layout>
  )
}

export default PendingInvoicesPage
